import React, { useState, Fragment } from 'react'

import { Combobox, Transition } from '@headlessui/react'
import { MapPinIcon } from '@heroicons/react/24/outline'

const AutocompleteInput = ({ selected, setSelected, data, placeholder }) => {
  const [query, setQuery] = useState('')
  const filteredDevice =
    query === ''
      ? data
      : data.filter((person) => {
        const pin = String(person?.pinCode || '').toLowerCase().replace(/\s+/g, '')
        const q = query.toLowerCase().replace(/\s+/g, '')
        const name = String(person?.name || '').toLowerCase().replace(/\s+/g, '')
        return pin.includes(q) || name.includes(q)
      })
  return (
    <div className="">
      <Combobox value={selected} onChange={setSelected}>
        <div className="relative mt-1">
          <div className="relative w-full overflow-hidden rounded-[20px] border border-slate-200 bg-white px-4 py-3 text-left shadow-[0_8px_22px_rgba(15,23,42,0.04)] transition-all focus-within:border-[#fdba74] focus-within:shadow-[0_12px_24px_rgba(249,115,22,0.08)] sm:text-sm">
            <div className="mb-1 flex items-center gap-2 text-[10px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400">
              <MapPinIcon className="h-3.5 w-3.5" />
              Pickup warehouse
            </div>
            <Combobox.Input
              className="w-full border-none bg-transparent text-[15px] leading-5 text-slate-900 outline-none placeholder:text-slate-400 focus:ring-0"
              displayValue={(person) => person?.name || person?.pinCode || ''}
              placeholder={placeholder}
              onChange={(event) => setQuery(event.target.value)}
            />

          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery('')}
          >
            <Combobox.Options className="absolute z-[999] mt-2 max-h-60 w-full overflow-auto rounded-[20px] border border-slate-200 bg-white py-2 text-base shadow-[0_20px_40px_rgba(15,23,42,0.12)] focus:outline-none sm:text-sm">
              {filteredDevice?.length === 0 && query !== '' ? (
                <div className="relative cursor-default select-none px-4 py-3 text-slate-500">
                  Nothing found.
                </div>
              ) : (
                filteredDevice?.map((person) => (
                  <Combobox.Option
                    key={person.id}
                    className={({ active }) =>
                      `relative cursor-default select-none rounded-2xl px-4 py-3 mx-2 ${active ? 'bg-[#1081E0] text-white' : 'text-slate-900'
                      }`
                    }
                    value={person}
                  >
                    {({ selected }) => (
                      <>
                        <span className={`block truncate text-sm ${selected ? 'font-[GilroyBold]' : 'font-[GilroyMedium]'}`}>
                          {person.pinCode} {person.name ? `- ${person.name}` : ''}
                        </span>
                        {person.city && (
                          <span className="mt-1 block truncate text-xs opacity-80">
                            {person.city}{person.state ? `, ${person.state}` : ''}
                          </span>
                        )}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  )
}

export default AutocompleteInput
